import { DateClass } from '@types';
import { formatInTimeZone } from 'date-fns-tz';

export const formatTimeRange = (
  openingHour: DateClass | number | undefined,
  closingHour: DateClass | number | undefined,
): string => {
  const openingDate =
    openingHour &&
    (typeof openingHour === 'number' ? new Date(openingHour * 1000) : new Date(openingHour.seconds * 1000));
  if (!openingDate) return '';

  const closingDate =
    closingHour &&
    (typeof closingHour === 'number' ? new Date(closingHour * 1000) : new Date(closingHour.seconds * 1000));

  const openingTime = formatInTimeZone(openingDate, 'Europe/London', 'h:mm aa');
  if (!closingDate) return `${openingTime}`;
  const closingTime = formatInTimeZone(closingDate, 'Europe/London', 'h:mm aa');

  const openingPeriod = openingDate && (openingDate.getHours() < 12 ? 'AM' : 'PM');
  const closingPeriod = closingDate && (closingDate.getHours() < 12 ? 'AM' : 'PM');

  if (
    (openingPeriod === 'PM' && closingPeriod === 'PM' && closingDate?.getHours() !== 0) ||
    (openingPeriod === 'AM' && closingPeriod === 'AM' && openingDate?.getHours() !== 0)
  ) {
    return `${openingTime?.split(' ')[0]}-${closingTime}`;
  }

  return `${openingTime}-${closingTime}`;
};

export const formatTime = (time: DateClass | undefined, formatString: string) => {
  if (formatString && time?.seconds) {
    // Convert Unix time to Date object
    const date = new Date(time.seconds * 1000);

    // Format the UK date
    return formatInTimeZone(date, 'Europe/London', formatString);
  }
  return null;
};

export const isTimePast = (time?: DateClass) => {
  const currentDate = new Date();
  if (!time) {
    console.error('No time provided');
    return false;
  }

  const formattedTime = formatTime(time, 'yyyy-MM-dd');
  const specialDate = formattedTime && new Date(formattedTime);

  if (!specialDate) {
    console.error('Invalid special date');
    return false;
  }
  return specialDate.getTime() >= currentDate.setHours(0, 0, 0, 0);
};
